module.exports = __webpack_public_path__ + "img/20200611_150535.5fb4ff6c.jpg";